import { instance } from "..";

export const getModesToDisplay = async (code) => {
  const response = await instance.get(`/api/web/modes`);
  return response.data;
};

// Authenticated: all built-in modes with isFavorited/locked/gamesLeft, etc.
export const getAllModes = async () => {
  const { data } = await instance.get("/api/mode/");
  return data;
};
